import { z } from "zod";
/** previousStepId is the step whose result produced this step's input. Null when the step opens a task. */
export const stepMetadataShape = {
    previousStepId: z.int().positive().nullable(),
};
export function withStepMetadata(schema) {
    return schema.extend(stepMetadataShape);
}
